import React, { useState } from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';

// NÄmä pois täältä
//import { useEffect } from 'react'
//import Speedometer from "./Speedometer";
//import CombinedGauge from "./CombinedGauge";
// import { Table, Button, Form } from 'react-bootstrap';
// import { useState, useEffect } from 'react';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import Modal from 'react-bootstrap/Modal';
// import Organizations from './MaintenanceOrganizations';
// import Personnel from './MaintenancePersonnel';
// import Sites from './MaintenanceSites';
// import Devices from './MaintenanceDevices';





// const Maintenance = ({database, main_callback}) => {

//     if (database) {

//     //const organizations = database['organizations'];
//     //var personnel = database['personnel'];
//     //var sites = database['sites'];
//     //var devices = database['devices'];

//     console.log('Maintenance', database);

//     return (
//         <div>
//             <h1>Maintenance</h1>

//             <Tabs
//                 defaultActiveKey="organizations"
//                 id="maintenance-tabs"
//                 className="mb-3"
//                 fill
//                 >

//                 <Tab eventKey="organizations" title="Organizations">
//                     <Organizations organizations={database['organizations']} main_callback={main_callback}/>
//                 </Tab>
//                 <Tab eventKey="personnel" title="Personnel">
//                     {/* <Personnel personnel={personnel} main_callback={main_callback}/> */}
//                     <Personnel database={database} main_callback={main_callback}/>
//                 </Tab>
//                 <Tab eventKey="sites" title="Sites">
//                     <Sites database={database} main_callback={main_callback}/>
//                 </Tab>
//                 <Tab eventKey="devices" title="Devices">
//                     <Devices database={database} main_callback={main_callback}/>
//                 </Tab>
//             </Tabs>

//             <p>Savcor 2024</p>
//         </div>
 
//     )

//     }

// }

// Kopioitu suoraan Overview.js:stä
const ToggleSwitch = ({ checked, onChange, label }) => (
  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "500",
      color: "#333",
    }}
  >

    <span>{label}</span>

    <div
      style={{
        position: "relative",
        width: "52px",
        height: "28px",
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={{
          opacity: 0,
          width: 0,
          height: 0,
        }}
      />
      <span
        style={{
          position: "absolute",
          inset: 0,
          background: checked
            ? "linear-gradient(135deg, #00c853, #b2ff59)"
            : "linear-gradient(135deg,rgb(20, 134, 241), rgb(158, 202, 243))",
          borderRadius: "999px",
          transition: "0.3s ease",
          boxShadow: "inset 0 0 4px rgba(7, 172, 248, 0.2)",
        }}
      />
      <span
        style={{
          position: "absolute",
          top: "4px",
          left: checked ? "28px" : "4px",
          width: "20px",
          height: "20px",
          background: "white",
          borderRadius: "50%",
          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
          transition: "left 0.3s ease",
        }}
      />
    </div>


  </label>
);



// HUOM! Pidä ajantasalla adminin ja maintenance välillä
// TODO: Nämä pitäisi ehkä olla jossain keskitetysti

const device_fields = [
    ['device_id', 'Device id'],
    ['user_id', 'User id'],
    ['location_id', 'Location id'],
    ['address', 'Address'],
    ['description', 'Description'],
];


const location_fields = [
    ['location_id', 'Location id'],
    ['user_id', 'User id'],
    ['device_id', 'Device id'],
    ['site_id', 'Site id'],
    ['description', 'Description'],
    ['x_origin', 'X origin'],
    ['y_origin', 'Y origin'],
    ['z_origin', 'Z origin'],
    ['alarm_limit_high', 'Alarm limit high'],
    ['alarm_limit_low', 'Alarm limit low'],
    ['email', 'Email'],
    ['email_enabled', 'Email enabled']
]

const link_fields = [
    ['device_id', 'Device id'],
    ['location_id', 'Location id'],
    ['user_id', 'User id']
]

const site_fields = [
    ['site_id', 'Site id'],
    ['user_id', 'User id'],
    ['description', 'Description']
]


const LastMeasurements = ({sensor, lastmeasurements}) => {
    if (!sensor || !lastmeasurements)
        return;
    
    console.log('LastMeasurements', 'sensor', sensor)
    //if (lastmeasurement == 0)
    //    return;

    var lastmeasurement = null;

    console.log('**lastmeasurements:',sensor, lastmeasurements[sensor], lastmeasurements)
    if (lastmeasurements[sensor] !== undefined) {
        //result = JSON.parse(lastmeasurement);
        lastmeasurement = lastmeasurements[sensor];
    }
    else {
        return <></>;
    }
    //let test = JSON.parse(lastmeasurement);
    //console.log('lastmeasurements:', test)
    //console.log('databasessa jotain', database.length)

    //var lastMeasurement = '';
    //var result = '';
    //var parseredDatabase = JSON.parse(database);
    /*
    var parseredDatabase = JSON.parse(database);
    // TODO: Tässä käydään nämä turhaan läpi kun otetaan vain viimeinen
    for (const avain in parseredDatabase) {
        lastMeasurement = parseredDatabase[avain][ parseredDatabase[avain].length - 1 ];
    }

    result = lastMeasurement;
    */

    // var result = lastmeasurement;
   console.log('****lastmeasurements:', lastmeasurement);

    //console.log('lastmeasurement:', lastmeasurement['sensor'])
    //console.log('parsered', JSON.stringify(result));//, parseredDatabase, ' => ', parseredDatabase['100000005'])
    // parsered {"time":"2025-04-16T07:22:23.60419325Z","timestamp":1744788143,"sensor":"100000005","battery_level":7, "temperature":27.0994,
    // "x_angle":0.546,"y_angle":0.2613,"z_angle":89.3947,"x_axis_acceleration":0.0096,"y_axis_acceleration":0.0046,"z_axis_acceleration":1.0025}
    //return JSON.stringify(result);
    return (
        <>
        { lastmeasurement && (
            <div>   
                Sensor: {lastmeasurement['sensor']}<br/>
                Time: {lastmeasurement['time']}<br/>
                Angles: x:{lastmeasurement['x_angle']}, y:{lastmeasurement['y_angle']}, y:{lastmeasurement['z_angle']}<br/>
                Acceleration: x:{lastmeasurement['x_axis_acceleration']}, y:{lastmeasurement['y_axis_acceleration']}, y:{lastmeasurement['z_axis_acceleration']}<br/>
                Temperature: {lastmeasurement['temperature']}<br/>
                Battery level: {lastmeasurement['battery_level']}<br/>
            </div>
        )}
        </>
    )
}







const Maintenance = ({selectedUser, devices, locations, sites, links, lastmeasurements, callback}) => {
    const [activeDeviceIndex, setActiveDeviceIndex] = useState(null);
    const [activeLocationIndex, setActiveLocationIndex] = useState(null);
    const [locationAddress, setLocationAddress] = useState(null);

    const [activeLinkIndex, setActiveLinkIndex] = useState(null);
    const [activeLinkDeviceIndex, setActiveLinkDeviceIndex] = useState(null);
    const [activeLinkLocationIndex, setActiveLinkLocationIndex] = useState(null);

    const [activeSiteIndex, setActiveSiteIndex] = useState(null);

    const [selectedDevice, setSelectedDevice] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    //const [locationState, setLocationState]  = useState('view'); // view/add/edit/delete
    const [selectedLink, setSelectedLink] = useState(null);

    const [selectedEditDevice, setSelectedEditDevice] = useState(null);

    const [selectedSite, setSelectedSite] = useState(null);


    const [userState, setUserState]  = useState('view'); // view/add/edit/delete
    const [deviceState, setDeviceState]  = useState('view'); // view/add/edit/delete
    const [locationState, setLocationState]  = useState('view'); // view/add/edit/delete
    const [linkState, setLinkState] = useState('view'); // link/unlink/null
    const [siteState, setSiteState] = useState('view'); // view/add/edit/delete

    const [infoMessage, setInfoMessage] = useState(""); // Info kenttä näytetään sivun alalaidassa

/*
  const [speed, setSpeed] = useState(0);
  const [rpm, setRpm] = useState(1000);

  useEffect(() => {
    const interval = setInterval(() => {
      setSpeed((prev) => (prev >= 100 ? 0 : prev + 5));
      setRpm((r) => (r >= 8000 ? 1000 : r + 500));
    }, 600);
    return () => clearInterval(interval);
  }, []);
*/

// Näyttää vihreällä infoviestin käyttäjälle 5 sekunnin ajan
const showInfoMessage = (message) => {
    setInfoMessage(message);

    // Piilotetaan viesti 5 sekunnin päästä
    setTimeout(() => {
        setInfoMessage("");
        console.log('infoviesti pois')
    }, 5000);
}


const DeviceFormReadOnly = ({selectedDevice}) => { 
    return (
        <>

        {device_fields.map((item) => {
            return (
                <div class="row" key={item[0]}>
                    <div class="col-sm">{item[1]}</div>
                    <div class="col-sm">{selectedDevice && selectedDevice[item[0]]}</div>
                </div>
            )
        })}                                


        </>
    )
}


const DeviceFormEditable = ({selectedDevice, onBlurDevice}) => {
    const [formData, setFormData] = useState(selectedDevice);

    const handleChange = (e) => {
        console.log('handleChange', formData)
        const { name, value } = e.target;
        setFormData({...formData, [name]: value});
    }


    return (
        <>
        
        {device_fields.map((item) => {
            return (
                <div className="row" >
                    <div className="col-sm">{item[1]}</div>
                    <input disabled={item[0] === "device_id" || item[0] === "user_id" || item[0] === "location_id"} type="text" className="col-sm" name={item[0]} value={formData[item[0]]} 
                        onChange={handleChange}
                        onBlur={(e) => onBlurDevice(formData)}
                    ></input>
                </div>                     
            )
        })}                                
        </>
    )
}

// GUI components

const DevicesGUI = () => {
    return (
        <>
            <h2>Devices</h2>

            <div class="container">
                <div class="row">

                    <div class="col-sm">

                        <ListGroup>
                            {selectedUser && devices && devices
                                .filter(dev => 
                                    dev.user_id === selectedUser.user_id// &&
                                    //(dev.location_id == null || dev.location_id == "null")
                                )
                                .map((device, index) =>
                                <ListGroup.Item 
                                    key={index} 
                                    disabled={deviceState !== 'view' || locationState !== 'view' || linkState != 'view'}
                                    active={index === activeDeviceIndex} 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => deviceClicked(device, index)}>
                                        {device.description}
                                </ListGroup.Item>

                            )}
                        </ListGroup>


                        <div class="m-2">
                            <Button variant="primary" disabled={!selectedUser || userState !== 'view' || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'} onClick={() => addDevice()}>Add</Button>
                            <Button variant="primary" disabled={userState !== 'view' || !selectedDevice || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'} onClick={() => editDevice(activeDeviceIndex)}>Edit</Button>
                            <Button variant="primary" disabled={userState !== 'view' || !selectedDevice || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'} onClick={() => deleteDevice(activeDeviceIndex)}>Delete</Button>
                        </div>

                    </div>

                    <div class="col-sm border rounded p-3">
                        {selectedUser && devices && devices[activeDeviceIndex] && deviceState === 'view' && 
                            <>
{/*                            
                                {device_fields.map((item) => {
                                    return (
                                    <div class="row" key={item[0]}>
                                        <div class="col-sm">{item[1]}</div>
                                        <div class="col-sm">{selectedDevice && selectedDevice[item[0]]}</div>
                                    </div>
                                    )
                                })}

*/}
                                <DeviceFormReadOnly selectedDevice={selectedDevice}></DeviceFormReadOnly>
{/*
                                {device_fields.map((item) => {
                                    return (

                                        <DeviceFormReadOnly item={item} selectedDevice={selectedDevice}></DeviceFormReadOnly>
                                    )
                                })}                                
*/}
{/*
                                {device_fields.map((item) => {
                                    return (

                                        <DeviceFormReadOnly item={item} selectedDevice={selectedDevice}></DeviceFormReadOnly>
                                    )
                                })}                                   
*/}                                    
                            </>
                        }

                        {/* Deviceä lisättäessä/muokattaessa */}
                        {selectedUser && selectedDevice && (deviceState === 'add' || deviceState === 'edit' || deviceState === 'delete') &&
                            <>
                                <DeviceFormEditable selectedDevice={selectedDevice} onBlurDevice={onBlurDevice}></DeviceFormEditable>
                                                            
{/*
                                {device_fields.map((item) => {
                                    return (

                                        <div class="row">
                                            <div class="col-sm">{item[1]}</div>
                                            <input class="col-sm" 
                                                disabled={item[0] === 'device_id' || item[0] === 'user_id' || item[0] === 'location_id'} 
                                                key={item[0]} 
                                                name={item[0]} 
                                                value={selectedDevice[item[0]]} 
                                                onChange={(event) => { 
                                                    const {name, value } = event.target;
                                                    setSelectedDevice({ 
                                                        ...selectedDevice, 
                                                        [name]: value
                                                    }); 
                                            }}></input>
                                        </div>                                        
                                    )
                                })}
*/}
                                <div class="col-sm  float-sm-right">
                                    <button class="btn btn-primary m-1" onClick={() => cancelDevice()}>Cancel</button>
                                    <button class="btn btn-primary m-1" onClick={() => okDevice()}>Ok</button>
                                </div>
                            </>
                        }                        
                    </div>


                </div>
            </div>

        
        </>
    )
}


const LocationFormReadOnly = ({selectedLocation}) => { 

    return (
        <>

        {location_fields.map((item) => {

            return (
                <div class="row" key={item[0]}>

                {/* Muut kuin "email_enabled* näytetään edit-kenttinä */}
                {(item[0] != "email_enabled" || locationAddress || locationAddress != undefined) && (
                    <>
                        <div class="col-sm">{item[1]}</div>

                        <div class="col-sm">{selectedLocation && selectedLocation[item[0]]}</div>

                        {/* x, y, z origin ja tämän hetkinen mittaus */} 
                        { item[0] === "x_origin" && (selectedLocation && lastmeasurements[locationAddress] !== undefined) ? ' (' + lastmeasurements[locationAddress]['x_angle'] + ')' : '' }
                        { item[0] === "y_origin" && (selectedLocation && lastmeasurements[locationAddress]) ? ' (' + lastmeasurements[locationAddress]['y_angle'] + ')' : '' }
                        { item[0] === "z_origin" && (selectedLocation && lastmeasurements[locationAddress]) ? ' (' + lastmeasurements[locationAddress]['z_angle'] + ')' : '' }
                    </>
                )}

                {/* Emailin enablointi sähköpostiosoitteen perään */}
                {/*
                {item[0] == "email_enabled" && 
                (  
                    <ToggleSwitch
                    checked={selectedLocation[item[1]] != undefined && selectedLocation[item[1]] == 1}
                    onChange={() => {
                        //const tmpOnlineStatus = !chartOnline;
                        //setChartOnline(tmpOnlineStatus);
                        //queryDatabase(tmpOnlineStatus);
                        console.log('email enable:', selectedLocation)

                        //console.log('handleChange', formData)
                        //const { name, value } = e.target;
                        //setFormData({...formData, [name]: value});                        
                        

                    }}
                    //label={"Email enabled " + selectedLocation[item[1]]}
                    label={"Email enabled (currently not in use)"}
                    /> 
                )}
*/}

                </div>
            )
        })}
        </>

            )
        }                                

/*
                    <ToggleSwitch
                        checked={chartOnline}
                        onChange={() => {
                            const tmpOnlineStatus = !chartOnline;
                            setChartOnline(tmpOnlineStatus);
                            queryDatabase(tmpOnlineStatus);
                        }}
                        label={chartOnline ? "Online" : "Database"}
                    />


*/

const LocationFormEditable = ({selectedLocation, onBlurLocation}) => {
    const [formData, setFormData] = useState(selectedLocation);

    const handleChange = (e) => {
        console.log('e:', e.target)
        console.log('handleChange', formData)
        const { name, value } = e.target;
        setFormData({...formData, [name]: value});
    }


    return (
        <>
        
        {location_fields.map((item) => {
            return (
                <div className="row" >
                    <div className="col-sm">{item[1]}</div>
                    {item[0] != 'device_id' ? (
                        <input disabled={item[0] === "device_id" || item[0] === "user_id" || item[0] === "location_id"} type="text" className="col-sm" name={item[0]} value={formData[item[0]]} 
                            onChange={handleChange}
                            onBlur={(e) => onBlurLocation(formData)}
                        ></input>
                    ) : (
                    <div class="col-sm-6">

                        <Dropdown>
                            <Dropdown.Toggle variant="primary" id="dropdown-basic" className="w-100">
                                {selectedLocation && selectedLocation['device_id']}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {/*
                                <Dropdown.Item
                                    key={99999}
                                    onClick={() => {
                                        setSelectedLocation(null);
                                        setLocationAddress(null);
                                    }}                                         
                                    >
                                        Select location
                                </Dropdown.Item>
                                */}
                                {devices && devices
                                    .filter(device => device.user_id === selectedLocation.user_id)  
                                    .map((currently_selected_device, index) =>
                                        <Dropdown.Item
                                            key={index}
                                            onClick={() => { 
                                                //setSelectedLocation(location);

                                                // Haetaan valittuun locationiin liitetyn laitteen address, jonka perusteella saadaan viimeisimmät mittaukset
                                                let dev_id = currently_selected_device['device_id'];
                                                let devFound = devices.find( element => element['device_id'] === dev_id );
                                                let address = (devFound) ? devFound['address'] : null;                                                
                                                //setLocationAddress(address);

                                                // Tehdään haku samalla
                                                // Locationia vaihdettaessa annetaan suoraan myös locationin sensor address. 
                                                // Hae napilla haetaan jo selectedLocationissa oleva location_id
                                                //let test = location['location_id'];
                                                //queryDatabase(chartOnline, location['location_id']);

                                                console.log('valittu:', currently_selected_device, ' / devFound:', devFound)

                                                //setSelectedLocation({...selectedLocation, device_id: dev_id});

                                                // Tehdään tässä e mikä menisi handleChangelle
                                                let e = { target: {name: "device_id", value: dev_id} };
                                                handleChange(e);

                                                // Näytettävässä alla jotain häikkää. Ei nyt tule oikea data näkyviin. TUTKI!!
                                            }}
                                            >
                                            
                                            {currently_selected_device.device_id}
                                        </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                        </div>
                    )}
                </div>                     
            )
        })}                                
        </>
    )
}

const LocationsGUI = () => {

    return (
        <>

            <h2>Locations</h2>

            <div class="container">
                <div class="row">

                    <div class="col-sm">

                        <ListGroup>
                            {selectedUser && locations && locations
                                .filter(loc => 
                                    loc.user_id === selectedUser.user_id // &&
                                    //(location.device_id == null || location.device_id == "null" || location.device_id == "")
                                )
                                .map((loca, index) =>
                                <ListGroup.Item 
                                    key={index} 
                                    disabled={deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'}
                                    active={index === activeLocationIndex} 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => locationClicked(loca, index)}>
                                        {loca.description} 
                                </ListGroup.Item>

                            )}
                        </ListGroup>




                        <div class="m-2">
                            <Button variant="primary" disabled={!selectedUser || userState !== 'view' || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'} onClick={() => addLocation()}>Add</Button>
                            <Button variant="primary" disabled={userState !== 'view' || !selectedLocation || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'} onClick={() => editLocation(activeLocationIndex)}>Edit</Button>
                            <Button variant="primary" disabled={userState !== 'view' || !selectedLocation || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'} onClick={() => deleteLocation(activeLocationIndex)}>Delete</Button>
                        </div>



                    </div>




                    <div class="col-sm border rounded p-3">
                        {locations && locations[activeLocationIndex] && locationState === 'view' && 
                            <>
                                <LocationFormReadOnly selectedLocation={selectedLocation}></LocationFormReadOnly>

                                <button class="btn btn-primary m-1" onClick={() => calibrate()}>Calibrate to zero</button>

                                <button class="btn btn-primary m-1" onClick={() => email()}>Test email</button>

                            </>
                        }

                        {/*Locationia lisättäessä/muokattaessa */}
                        {selectedUser && selectedLocation && (locationState === 'add' || locationState === 'edit' || locationState === 'delete') && 
                            <>

                                <LocationFormEditable selectedLocation={selectedLocation} onBlurLocation={onBlurLocation} />

                                <div class="col-sm  float-sm-right">
                                    <button class="btn btn-primary m-1" onClick={() => cancelLocation()}>Cancel</button>
                                    <button class="btn btn-primary m-1" onClick={() => okLocation()}>Ok</button>
                                </div>
                            </>
                        }                        
                    </div>


                </div>
            </div>

            </>
    )

}


const LinksGUI = () => {
    return (
        <>
                <h2>Links</h2>

            <div class="container">
                <div class="row">

                    <div class="col-sm">
                        <ListGroup>
                            {selectedUser && links && links
                                .filter(link => link.user_id === selectedUser.user_id)
                                .map((link, index) =>
                                <ListGroup.Item 
                                    key={index} 
                                    disabled={deviceState !== 'view' || locationState !== 'view' || linkState !== "view"}
                                    active={index === activeLinkIndex} 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => linkClicked(link, index)}>
                                        {link.link_id}
                                </ListGroup.Item>

                            )}
                        </ListGroup>
                    </div>


                        <div class="m-2">
                            <Button variant="primary" disabled={!selectedUser || userState !== 'view' || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'} onClick={() => addLink()}>Add</Button>
                            {/* Poistettu käytöstä <Button variant="primary" disabled={userState !== 'view' || deviceState !== 'view' || locationState !== 'view' || !selectedLink || linkState !== 'view'} onClick={() => editLink(activeLinkIndex)}>Edit</Button> */}
                            <Button variant="primary" disabled={userState !== 'view' || deviceState !== 'view' || locationState !== 'view' || !selectedLink || linkState !== 'view'} onClick={() => deleteLink(activeLinkIndex)}>Delete</Button>
                        </div>

                        {/*Linkkiä lisättäessä/muokattaessa */}
                        {selectedLink && (linkState === 'add' || linkState === 'edit') &&
                            <>
                                <div class="row">


                                    <div class="col-sm">

                                        <ListGroup>
                                            {selectedUser && devices && devices
                                                .filter(dev => dev.user_id === selectedUser.user_id 
                                                    && (dev['location_id'] === undefined || dev.location_id === null || dev.location_id === "")
                                                )
                                                .map((device, index) =>
                                                    <ListGroup.Item
                                                        key={index}
                                                        active={index === activeLinkDeviceIndex}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => linkDeviceClicked(device, index)}>
                                                        {device.description}
                                                    </ListGroup.Item>

                                                )}
                                        </ListGroup>
                                    </div>


                                    <div class="col-sm">


                                        <ListGroup>
                                            {selectedUser && locations && locations
                                                .filter(loc => loc.user_id === selectedUser.user_id
                                                    && (loc['device_id'] === undefined || loc.device_id === null || loc.device_id === "")
                                                )
                                                .map((loc, index) =>
                                                    <ListGroup.Item
                                                        key={index}
                                                        active={index === activeLinkLocationIndex}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => linkLocationClicked(loc, index)}>
                                                        {loc.description} 
                                                    </ListGroup.Item>

                                                )}
                                        </ListGroup>

                                    </div>

                                </div>





                                <div class="col-sm  float-sm-right">
                                    <button class="btn btn-primary m-1" onClick={() => cancelLink()}>Cancel</button>
                                    <button class="btn btn-primary m-1" onClick={() => okLink()}>Ok</button>
                                </div>
                            </>
                        }

                        {/* Linkkiä poistettaessa */}
                        {selectedLink && linkState === 'delete' && 
                            <>
                                <div class="col-sm  float-sm-right">
                                    <button class="btn btn-primary m-1" onClick={() => cancelLink()}>Cancel</button>
                                    <button class="btn btn-primary m-1" onClick={() => okLink()}>Ok</button>
                                </div>                            
                            </>
                        }


                    </div>


            </div>
            </>
    )
}


const SiteFormReadOnly = ({selectedSite}) => { 
    return (
        <>
        {site_fields.map((item) => {
            return (
                <div class="row" key={item[0]}>
                    <div class="col-sm">{item[1]}</div>
                    <div class="col-sm">{selectedSite && selectedSite[item[0]]}</div>
                </div>
            )
        })}                                


        </>
    )
}


const SiteFormEditable = ({selectedSite, onBlurSite}) => {
    const [formData, setFormData] = useState(selectedSite);

    const handleChange = (e) => {
        console.log('handleChange', formData)
        const { name, value } = e.target;
        setFormData({...formData, [name]: value});
    }


    return (
        <>
        {site_fields.map((item) => {
            return (
                <div className="row" >
                    <div className="col-sm">{item[1]}</div>
                    <input disabled={item[0] === "site_id" || item[0] === "user_id" || item[0] === "location_id"} type="text" className="col-sm" name={item[0]} value={formData[item[0]]} 
                        onChange={handleChange}
                        onBlur={(e) => onBlurSite(formData)}
                    ></input>
                </div>                     
            )
        })}                                
        </>
    )
}

// GUI components

const SitesGUI = () => {
    return (
        <>
            <h2>Sites</h2>

            <div class="container">
                <div class="row">

                    <div class="col-sm">

                        <ListGroup>
                            {selectedUser && sites && sites
                                .filter(site => 
                                    site.user_id === selectedUser.user_id// &&
                                    //(dev.location_id == null || dev.location_id == "null")
                                )
                                .map((site, index) =>
                                <ListGroup.Item 
                                    key={index} 
                                    disabled={siteState !== 'view'}
                                    active={index === activeSiteIndex} 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => siteClicked(site, index)}>
                                        {site.description}
                                </ListGroup.Item>

                            )}
                        </ListGroup>


                        <div class="m-2">
                            <Button variant="primary" disabled={!selectedUser || userState !== 'view' || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view'} onClick={() => addSite()}>Add</Button>
                            <Button variant="primary" disabled={userState !== 'view' || siteState !== 'view' || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view' || !selectedSite} onClick={() => editSite(activeSiteIndex)}>Edit</Button>
                            <Button variant="primary" disabled={userState !== 'view' || siteState !== 'view' || deviceState !== 'view' || locationState !== 'view' || linkState !== 'view' || !selectedSite} onClick={() => deleteSite(activeSiteIndex)}>Delete</Button>
                        </div>

                    </div>



                    <div class="col-sm border rounded p-3">


                        {selectedUser && sites && sites[activeSiteIndex] && siteState === 'view' && 
                            <>
                                <SiteFormReadOnly selectedSite={selectedSite}></SiteFormReadOnly>
                            </>
                        }

                        {/* Deviceä lisättäessä/muokattaessa */}
                        {selectedUser && selectedSite && (siteState === 'add' || siteState === 'edit' || siteState === 'delete') &&
                            <>
                                <SiteFormEditable selectedSite={selectedSite} onBlurSite={onBlurSite}></SiteFormEditable>
                                                            
{/*
                                {device_fields.map((item) => {
                                    return (

                                        <div class="row">
                                            <div class="col-sm">{item[1]}</div>
                                            <input class="col-sm" 
                                                disabled={item[0] === 'device_id' || item[0] === 'user_id' || item[0] === 'location_id'} 
                                                key={item[0]} 
                                                name={item[0]} 
                                                value={selectedDevice[item[0]]} 
                                                onChange={(event) => { 
                                                    const {name, value } = event.target;
                                                    setSelectedDevice({ 
                                                        ...selectedDevice, 
                                                        [name]: value
                                                    }); 
                                            }}></input>
                                        </div>                                        
                                    )
                                })}
*/}
                                <div class="col-sm  float-sm-right">
                                    <button class="btn btn-primary m-1" onClick={() => cancelSite()}>Cancel</button>
                                    <button class="btn btn-primary m-1" onClick={() => okSite()}>Ok</button>
                                </div>
                            </>
                        }                        
                    </div>


                </div>
            </div>
        </>
    )
}



    const addDevice = () => {
        console.log('Clicked add device')
        //callback("adduser", "toka", "kolmas");
        setDeviceState('add');

        // Lisätään uusi käyttäjä, jota aletaan editoimaan. 
        setActiveDeviceIndex(-1);
        let addNewDevice = new Object();
        addNewDevice['user_id'] = selectedUser.user_id;
        addNewDevice['device_id'] = 'new';
        addNewDevice['address'] = '';
        addNewDevice['site'] = '';
        addNewDevice['description'] = '';
        addNewDevice['x_origin'] = 0.0;
        addNewDevice['y_origin'] = 0.0;
        addNewDevice['z_origin'] = 0.0;

        //!!setSelectedEditUser(addNewUser);
        setSelectedDevice(addNewDevice);
    }

    const editDevice = (index) => {
        console.log('Clicked edit device', index)
        console.log('editable device', devices[index])
        setDeviceState('edit');


    }

    const deleteDevice = (index) => {
        console.log('Clicked delete device', index)
        console.log('delete device', devices[index])
        setDeviceState('delete');
    }

    const okDevice = () => {
        // Lähetetään käyttäjän tiedot backendille
        // action, sender, data
        let message = new Object();
        message['command'] = `${deviceState}device`;
        message['sender'] = 'admin';
        message['data'] = selectedDevice;
        console.log('ok:', selectedDevice)


        //callback('adduser', 'admin', selectedEditUser);
        callback('command', 'admin', message);

        // TODO: Mieti miten tämä pitäisi tehdä. 
        //setActiveDeviceIndex(0);
        //setSelectedEditUser(null);
        //setSelectedDevice(devices[0]);

        setDeviceState('view');        
    }

    const cancelDevice = () => {
        setActiveDeviceIndex(0);
        setSelectedEditDevice(null);
        setDeviceState('view');        
    }    

    // Poistuttaessa input-kentästä
    const onBlurDevice = (formDataDevice) => {
        console.log('onSubmit:', formDataDevice)
        setSelectedDevice(formDataDevice);
    }



    const addLocation = () => {
        console.log('Clicked add location')
        //callback("adduser", "toka", "kolmas");
        setLocationState('add');

        // Lisätään uusi sijainti, jota aletaan editoimaan. 
        setActiveLocationIndex(-1);
        let addNew = new Object();
        addNew['location_id'] = 'new';
        addNew['device_id'] = '';//selectedDevice.device_id;
        addNew['user_id'] = selectedUser.user_id;
        addNew['site_id'] = '';
        addNew['description'] = '';
        addNew['x_origin'] = 0.0;
        addNew['y_origin'] = 0.0;
        addNew['z_origin'] = 0.0;
        addNew['alarm_limit_low'] = 0.0;
        addNew['alarm_limit_high'] = 0.0;
        addNew['email'] = '';
        addNew['email_enabled'] = true;

        //!!setSelectedEditUser(addNewUser);
        setSelectedLocation(addNew);
    }

    const editLocation = (index) => {
        console.log('Clicked edit location', index)
        console.log('editable location', locations[index])
        setLocationState('edit');


    }

    const deleteLocation = (index) => {
        console.log('Clicked delete location', index)
        console.log('delete location', locations[index])
        setLocationState('delete');
    }

    const okLocation = () => {
        // Lähetetään käyttäjän tiedot backendille
        // action, sender, data
        let message = new Object();
        message['command'] = `${locationState}location`;
        message['sender'] = 'admin';
        message['data'] = selectedLocation;
        console.log('ok:', selectedLocation)


        //callback('adduser', 'admin', selectedEditUser);
        callback('command', 'admin', message);

        // TODO: Mieti miten tämä pitäisi tehdä. 
        //setActiveDeviceIndex(0);
        //setSelectedEditUser(null);
        //setSelectedDevice(devices[0]);

        setLocationState('view');        
    }

    const cancelLocation = () => {
        setActiveLocationIndex(0);
        //setSelectedEditLocation(null);
        setLocationState('view');        
    } 

        // Poistuttaessa input-kentästä
    const onBlurLocation = (formDataLocation) => {
        console.log('onSubmit:', formDataLocation)
        setSelectedLocation(formDataLocation);
    }

    
    // LINK
    const addLink = () => {
        console.log('Clicked add link')
        //callback("adduser", "toka", "kolmas");
        setLinkState('add');

        // Lisätään uusi sijainti, jota aletaan editoimaan. 
        setActiveLinkIndex(-1);
        let addNew = new Object();
        addNew['user_id'] = selectedUser.user_id;
        addNew['device_id'] = '';
        addNew['location_id'] = '';

        //!!setSelectedEditUser(addNewUser);
        setSelectedLink(addNew);
        console.log('addlink', addNew, '->', selectedLink)

        // Irrotetaan valitut device ja location
        setSelectedDevice(null);
        setSelectedLocation(null);
        setActiveDeviceIndex(null);
        setActiveLocationIndex(null);
        setActiveLinkDeviceIndex(null);
        setActiveLinkLocationIndex(null);
    }

    const editLink = (index) => {
        console.log('Clicked edit link', index)
        console.log('editable link', links[index])
        setLinkState('edit');


    }

    const deleteLink = (index) => {
        console.log('Clicked delete link', index)
        console.log('delete link', links[index])
        setLinkState('delete');
    }

    const okLink = () => {
        console.log('selectedDevice', selectedDevice)
        console.log('selectedLocation', selectedLocation)
        console.log('selectedLink', selectedLink)
        console.log('selectedUser', selectedUser)

        //console.log('okLink ok link:', selectedLink['link_id'], 'state:', linkState)
        //console.log('okLink deviceid:', selectedDevice['device_id'])
        //console.log('okLink location_id:', selectedLocation['location_id'])
        //console.log('selectedDevice', selectedDevice)
        //console.log('selectedLocation', selectedLocation)


//        if (!selectedDevice || !selectedLocation || !selectedUser || selectedLink)
//            return;

        if (!selectedDevice || !selectedLocation || !selectedUser || !selectedLink) {
            console.log('vituiks män');
            return;
        }

        /*
        setSelectedLink({
            ...selectedLink,
            ['device_id']: selectedDevice['device_id'],
            ['location_id']: selectedLocation['location_id']
        })*/


        // TODO: Tämä väliaikaisesti koska setSelecteLink ei ehdi päivittää ominaisuuksia ennen kuin ne lähetetään eteenpäin
        let newLink = new Object();

        if (linkState === "add" || linkState === "edit") {
            newLink['device_id'] = selectedDevice['device_id'];
            newLink['location_id'] = selectedLocation['location_id'];
            newLink['user_id'] = selectedUser['user_id'];
            newLink['link_id'] = selectedLink['link_id'];
            
            setSelectedLink({
                ...selectedLink,
                ['device_id']: selectedDevice['device_id'],
                ['location_id']: selectedLocation['location_id']
            })            
        }
        else {
            newLink = selectedLink;
        }

        // Lähetetään käyttäjän tiedot backendille
        // action, sender, data
        let message = new Object();
        message['command'] = `${linkState}link`;
        message['sender'] = 'admin';
        message['data'] = newLink;
        console.log('ok:', newLink)


        //callback('adduser', 'admin', selectedEditUser);
        callback('command', 'admin', message);

        // Lisätään vielä Devicelle locationID ja Locationille DeviceId, niin on molemmat valmiiksi päivittyneenä kun lisätään
        setSelectedDevice({...selectedDevice, ['location_id']: selectedLocation['location_id']});
        setSelectedLocation({...selectedLocation, ['device_id']: selectedDevice['device_id']});

        // TODO: Mieti miten tämä pitäisi tehdä. 
        //setActiveDeviceIndex(0);
        //setSelectedEditUser(null);
        //setSelectedDevice(devices[0]);

/*

        // Linkitetään ensin location deviceen
        if (selectedDevice) {
            let message = new Object();
            message['command'] = `editdevice`;
            message['sender'] = 'admin';
            message['data'] = selectedDevice;
            console.log('ok:', selectedDevice)

            callback('command', 'admin', message);
        }


        // Ja sitten device locationiin
        if (selectedLocation) {
            let message = new Object();
            message['command'] = `editlocation`;
            message['sender'] = 'admin';
            message['data'] = selectedLocation;
            console.log('ok:', selectedLocation)

            callback('command', 'admin', message);
        }
*/



        setLinkState('view');        
    }

    const cancelLink = () => {
        setActiveLinkIndex(0);
        //setSelectedEditLocation(null);
        setLinkState('view');        
    } 

    // ..LINK


    // SITE
    const addSite = () => {
        console.log('Clicked add site')
        console.log('selecteduser', selectedUser.user_id)
        //callback("adduser", "toka", "kolmas");
        setSiteState('add');

        // Lisätään uusi käyttäjä, jota aletaan editoimaan. 
        setActiveSiteIndex(-1);
        let addNewSite = new Object();
        addNewSite['user_id'] = selectedUser.user_id;
        addNewSite['site_id'] = 'new';
        addNewSite['description'] = '';
        //!!setSelectedEditUser(addNewUser);
        setSelectedSite(addNewSite);
    }

    const editSite = (index) => {
        console.log('Clicked edit site', index)
        console.log('editable site', sites[index])
        setSiteState('edit');


    }

    const deleteSite = (index) => {
        console.log('Clicked delete site', index)
        console.log('delete site', sites[index])
        setSiteState('delete');
    }

    const okSite = () => {
        // Lähetetään siten tiedot backendille
        // action, sender, data
        let message = new Object();
        message['command'] = `${siteState}site`;
        message['sender'] = 'admin';
        message['data'] = selectedSite;
        console.log('ok:', selectedSite)


        //callback('adduser', 'admin', selectedEditUser);
        callback('command', 'admin', message);

        // TODO: Mieti miten tämä pitäisi tehdä. 
        //setActiveDeviceIndex(0);
        //setSelectedEditUser(null);
        //setSelectedDevice(devices[0]);

        setSiteState('view');        
    }

    const cancelSite = () => {
        setActiveSiteIndex(0);
        //setSelectedEditSite(null);
        setSiteState('view');        
    }    

    // Poistuttaessa input-kentästä
    const onBlurSite = (formDataSite) => {
        console.log('onSubmit:', formDataSite)
        setSelectedSite(formDataSite);
    }


    // ..SITE

// .. GUI components













    const deviceClicked = (device, index) => {
        setActiveDeviceIndex(index);
        
        // Indeksi vaihtelee klikataanko device-luetteloa vai linkkiä lisättäessä device-luetteloa
        //let device_index = devices.findIndex(x => x.device_id === device.device_id);
        //setActiveDeviceIndex(device_index);        

        console.log('device:', device)
        
        setSelectedDevice(device);
        console.log('clicked device', device.description)
    }

    const locationClicked = (location, index) => {
        console.log('location clicked:', index, location)
        setActiveLocationIndex(index);
        setSelectedLocation(location);
        console.log('clicked location', location)
        console.log('devices', devices)
/* TODO: Poista. Nämä otettu pois käytöstä koska ei toimi jos ei jo ole liitetty laitetta locationille
        // Otetaan tämän hetkinen location talteen
        let dev_id = location['device_id'];
        let devFound = devices.find( element => element['device_id'] === dev_id );
        let address = (devFound) ? devFound['address'] : null;    
        
        console.log('location:', dev_id, devFound, address)
  
        setLocationAddress(address);        
        */
    }        


    const linkClicked = (link, index) => {
        console.log('link clicked:', index, link)
        setActiveLinkIndex(index);
        setSelectedLink(link);
        console.log('clicked link', link)


        console.log('devices:', devices)
        console.log('locations:', locations)

        // Asetetaan linkin device ja location valituiksi
        const deviceIndexFound = devices.findIndex(element => 
            element['device_id'] === link['device_id']
        );
        setActiveDeviceIndex(deviceIndexFound);
        setSelectedDevice(devices[deviceIndexFound]);

        const locationIndexFound = locations.findIndex(element => 
            element['location_id'] === link['location_id']
        ); 
        console.log('locationIndex:', locationIndexFound)
        setActiveLocationIndex(locationIndexFound);
        setSelectedLocation(locations[locationIndexFound]);

    }    


    const linkDeviceClicked = (device, index) => {
        setActiveLinkDeviceIndex(index);
        
        // Indeksi vaihtelee klikataanko device-luetteloa vai linkkiä lisättäessä device-luetteloa
        let device_index = devices.findIndex(x => x.device_id === device.device_id);
        setActiveDeviceIndex(device_index);        
        
        setSelectedDevice(device);
        console.log('clicked device', device.description)
    }

    const linkLocationClicked = (location, index) => {
        setActiveLinkLocationIndex(index);
        
        // Indeksi vaihtelee klikataanko device-luetteloa vai linkkiä lisättäessä device-luetteloa
        let location_index = locations.findIndex(x => x.location_id === location.location_id);
        setActiveLocationIndex(location_index);        

        //console.log('location clicked:', index, location)
        //setActiveLocationIndex(index);
        setSelectedLocation(location);
        console.log('clicked location', location)

        // Otetaan tämän hetkinen location talteen
        let dev_id = location['device_id'];
        let devFound = devices.find( element => element['device_id'] === dev_id );
        let address = (devFound) ? devFound['address'] : null;                                                
        setLocationAddress(address);        
    }        


    const siteClicked = (site, index) => {
        setActiveSiteIndex(index);
        
        // Indeksi vaihtelee klikataanko device-luetteloa vai linkkiä lisättäessä device-luetteloa
        //let device_index = devices.findIndex(x => x.device_id === device.device_id);
        //setActiveDeviceIndex(device_index);        

        console.log('site:', site)
        
        setSelectedSite(site);
        console.log('clicked site', site.description)
    }



    const getDeviceAddress = () => {
        // Haetaan valittuun locationiin liitetyn laitteen address, jonka perusteella saadaan viimeisimmät mittaukset
        let dev_id = selectedLocation['device_id'];
        let devFound = devices.find( element => element['device_id'] === dev_id );
        let address = (devFound) ? devFound['address'] : null;       
        
        return address;
    }

    const calibrate = () => {
        console.log('calibrate:', selectedDevice, selectedLocation, lastmeasurements)

        // Vahvistus
        const ok = window.confirm("Haluatko varmasti nollata");
        if (ok)
            console.log('confirmation ok');
        else {
            console.log('confirmation cancelled');
            return;
        }

        // Haetaan valittuun locationiin liitetyn laitteen address, jonka perusteella saadaan viimeisimmät mittaukset
        //let dev_id = selectedLocation['device_id'];
        //let devFound = devices.find( element => element['device_id'] === dev_id );
        //let address = (devFound) ? devFound['address'] : null;
        let address = getDeviceAddress()
        
        //console.log('calibrate; dev_id:', dev_id, 'devFound:', devFound, 'address:', address, 'lastMeasurements:', lastmeasurements[address])

        // Jotain infoa puuttuu -> hypätään pois
        // TODO: Pitäisi jotenkin ilmoittaa käyttäjälle
        if (address === null || address === undefined || lastmeasurements[address] === undefined) {
            console.log('calibrate failed')
            return;
        }
        
        //let parsedMeasurement = JSON.parse(lastmeasurement[address]);
        let parsedMeasurement = lastmeasurements[address];
        let locationToUpdate = selectedLocation;

        console.log('Calibrate:', selectedLocation)
        console.log('last measurement:', lastmeasurements[address])
        console.log('x:', parsedMeasurement['x_angle'])
        console.log('y:', parsedMeasurement['y_angle'])
        console.log('z:', parsedMeasurement['z_angle'])


        setSelectedLocation({
            ...selectedLocation,
            ['x_origin']: parsedMeasurement['x_angle'],
            ['y_origin']: parsedMeasurement['y_angle'],
            ['z_origin']: parsedMeasurement['z_angle'],
        });

        console.log('selectedLocation:', selectedLocation)


        locationToUpdate['x_origin'] = parsedMeasurement['x_angle'];
        locationToUpdate['y_origin'] = parsedMeasurement['y_angle'];
        locationToUpdate['z_origin'] = parsedMeasurement['z_angle'];
        console.log('location to update:', locationToUpdate)

        let message = new Object();
        message['command'] = 'editlocation';
        message['sender'] = 'admin';
        message['data'] = locationToUpdate;
        callback('command', 'admin', message);
    }

    const email = () => {
        if (selectedLocation['email'] != undefined) {
            console.log('email', selectedLocation['email']);

            
            // Backendille komento: lähetä testiemail käyttäjälle
             let emailMessage = new Object();
             emailMessage['email'] = selectedLocation['email'];
             emailMessage['subject'] = "Tilt test";
             emailMessage['message'] = "Tilt test message";          

            let message = new Object();
            message['command'] = 'email';
            message['sender'] = 'maint';
            message['data'] = emailMessage;            
            callback('command', 'maint', message);

            // Näytetään infoviesti
            showInfoMessage("Testisähköposti lähetetty osoitteeseen " + selectedLocation['email']);
        }
        else {
            console.log('email osoitetta ei löytynyt')
        }
    }


    //if (database.length = 0) {
    //    return <h1>kesken</h1>;
    //}
    var last = '';//lastMeasurements(database);
    
    //console.log('TESTAUS:', getDeviceAddress())
    //var last = lastMeasurements(database);
    //console.log('last measurements:', last)

    return (
        <div>
            <h1>Maintenance</h1>

            <p>{selectedUser && selectedUser['description']}</p>
            {/*<p>{devices && devices[0] && devices[0]['description']}</p>*/}


 


{/*

            <h2>Devices</h2>

            <div class="container">
                <div class="row">

                    <div class="col-sm">

                        <ListGroup>
                            {devices && devices.map((device, index) =>
                                <ListGroup.Item 
                                    key={index} 
                                    active={index === activeDeviceIndex} 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => deviceClicked(device, index)}>
                                        {device.description}
                                </ListGroup.Item>

                            )}
                        </ListGroup>
                    </div>

                    <div class="col-sm border rounded p-3">
                        {devices && devices[activeDeviceIndex] &&
                            <>
                                <div class="row">
                                    <div class="col-sm">Device id</div>
                                    <div class="col-sm">{devices && devices[activeDeviceIndex] && devices[activeDeviceIndex]['device_id']}</div>
                                </div>
                                <div class="row">
                                    <div class="col-sm">Address</div>
                                    <div class="col-sm">{devices && devices[activeDeviceIndex] && devices[activeDeviceIndex]['address']}</div>
                                </div>
                                <div class="row">
                                    <div class="col-sm">User id</div>
                                    <div class="col-sm">{devices && devices[activeDeviceIndex] && devices[activeDeviceIndex]['user_id']}</div>
                                </div>
                                <div class="row">
                                    <div class="col-sm">Site</div>
                                    <div class="col-sm">{devices && devices[activeDeviceIndex] && devices[activeDeviceIndex]['site']}</div>
                                </div>
                                <div class="row">
                                    <div class="col-sm">Description</div>
                                    <div class="col-sm">{devices && devices[activeDeviceIndex] && devices[activeDeviceIndex]['description']}</div>
                                </div>
                            </>
                        }
                    </div>


                </div>
            </div>
            */}
        {/*<LinksGUI></LinksGUI>*/}

        <SitesGUI></SitesGUI>
        <LocationsGUI></LocationsGUI>
        <DevicesGUI></DevicesGUI>


            {/*<Speedometer speed={speed} />*/}
            <br/>
            {/*<LastMeasurements lastmeasurement={selectedDevice && selectedDevice['address'] && lastmeasurement[selectedDevice['address']]} />*/}
            <LastMeasurements sensor={locationAddress} lastmeasurements={lastmeasurements} />

        {infoMessage && (
            <div style={{
            padding: "10px",
            marginTop: "10px",
            backgroundColor: "lightgreen"
            }}>
                {infoMessage}
            </div>
        )}

        </div>
    )
}


export default Maintenance
